import { Component, OnInit } from "@angular/core";
import { ComponentBase } from "../../models/ComponentBase";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UpsertProjectCo2Request } from "../../WebApiClient";
import { ProjectCo2Service } from "../../services/projectco2.service";
import { ToastService } from "../../services/toast.service";
import { BlockNavigationIfChange } from "../../guards/block-onchanged.guard";
import { Observable } from "rxjs";

@Component({
    selector: "app-sustainability-disclaimer",
    templateUrl: "./sustainability-disclaimer.component.html",
    styleUrls: [
        "./sustainability-disclaimer.component.scss",
        "../../style/sidebarLayout.scss",
        "../../style/form-table.scss",
    ],
    standalone: false,
})
export class SustainabilityDisclaimerComponent
    extends ComponentBase
    implements OnInit, BlockNavigationIfChange
{
    faBack: IconDefinition = faChevronCircleLeft;

    public projectCo2Consumption: UpsertProjectCo2Request;

    editDisclaimerFormGroup: FormGroup = new FormGroup({
        disclaimer: new FormControl(false, [Validators.required]),
    });

    hasChanges: () => Observable<boolean> | Promise<boolean> | boolean;

    constructor(
        private readonly router: Router,
        private readonly projectCo2Service: ProjectCo2Service,
        private readonly toastService: ToastService
    ) {
        super();

        this.projectCo2Consumption = new UpsertProjectCo2Request();

        this.hasChanges = () => false;

        this.editDisclaimerFormGroup.valueChanges.subscribe(() => {
            this.hasChanges = () => this.editDisclaimerFormGroup.dirty && this.editDisclaimerFormGroup.touched;
        });
    }

    ngOnInit(): void {
        let projectCo2ConsumptionSubscription = this.projectCo2Service
            .getProjectCo2()
            .subscribe((c) => this.setProjectCo2Consumption(c));

        this.subscriptions.push(projectCo2ConsumptionSubscription);
    }

    private setProjectCo2Consumption(
        c: UpsertProjectCo2Request | undefined
    ): void {
        if (c === undefined) {
            return;
        }
        this.projectCo2Consumption.disclaimer = c.disclaimer;
        this.projectCo2Consumption.portCrane = c.portCrane;
        this.projectCo2Consumption.mobileCrane = c.mobileCrane;
        this.projectCo2Consumption.vesselCrane = c.vesselCrane;
        this.projectCo2Consumption.vesselPower = c.vesselPower;
        this.projectCo2Consumption.shorePower = c.shorePower;

        this.editDisclaimerFormGroup.patchValue(this.projectCo2Consumption);
    }

    onDisclaimerSubmit() {
        if (!this.editDisclaimerFormGroup.valid) {
            this.disclaimerControl.markAsTouched();
            return;
        }

        this.projectCo2Consumption.disclaimer = this.disclaimerControl.value;

        this.projectCo2Service
            .upsert(this.projectCo2Consumption)
            .then(() =>
                this.toastService.add(
                    "Saved success",
                    "Disclaimer has been updated",
                    "success"
                )
            );

        this.editDisclaimerFormGroup.markAsPristine();
    }

    back() {
        this.router.navigate(["/sustainability"]);
    }

    public get disclaimerControl(): FormControl {
        return this.editDisclaimerFormGroup.get("disclaimer") as FormControl;
    }
}
